<script>
  import SubHeader from "../components/SubHeader.svelte";

  let subHeader = {
    bg_pc: '/images/sub_brand.png',
    bg_mo: '/images/sub_brand_m.png',
    title: '브랜드 스토리',
    dsc: '커피멘토는 프리미엄 무인 카페 브랜드입니다.'
  }
</script>

<SubHeader { ...subHeader }/>

<section class="brand">
  <div class="brand__peopleless">
    <div class="brand__peopleless-header header header_sub">
      <h1 class="header__heading heading heading_level_3">
        프리미엄
        <span class="_newline" />
        24시 무인 카페,
        <span class="_newline"/>
        커피 멘토
      </h1>
      <p class="header__text text">
        커피멘토는 고품질 음료와 프리미엄 인테리어로<span class="_newline" />
        24시간 운영이 가능한 무인 카페입니다.<br/>
        고객은 쉽고 간편하게 매장을 이용할 수 있고<br/>
        가맹 점주는 인건비를 줄여 더 높은 수익을 올릴<span class="_newline" />
        수 있는 프리미엄 무인 카페 브랜드입니다.
      </p>
    </div>
    <img class="brand__peopleless-img" src="/images/peopleless.png" alt="무인카페 커피멘토"/>
  </div>

  <div class="brand__value brand-value">
    <div class="header header_sub">
      <h1 class="header__heading heading heading_level_3">기업 가치</h1>
      <p class="header__text text">
        커피멘토는 고품질 음료와 프리미엄 인테리어로<span class="_newline" />
        24시간 운영이 가능한 무인 카페입니다.
      </p>
    </div>
    <div class="brand-value__content">
      <div class="brand-value__item">
        <div class="brand-value__symbol">
          <img class="brand-value__symbol-img" src="/images/business_value01.svg" alt="만족"/>
          <span class="brand-value__symbol-alt">만족</span>
        </div>
        <p class="brand-value__dsc text">
          음료의 품질, 인테리어 등 고객의 만족을<br/>
          최우선으로 하여 브랜드를 운영합니다.
        </p>
      </div>
      <div class="brand-value__item">
        <div class="brand-value__symbol">
          <img class="brand-value__symbol-img" src="/images/business_value02.svg" alt="경험"/>
          <span class="brand-value__symbol-alt">경험</span>
        </div>
        <p class="brand-value__dsc text">
          매장을 이용하는 고객에게 편안한
          <br/>
          경험을 제공하는 것을 목표로 합니다.
        </p>
      </div>
      <div class="brand-value__item">
        <div class="brand-value__symbol">
          <img class="brand-value__symbol-img" src="/images/business_value03.svg" alt="함께"/>
          <span class="brand-value__symbol-alt">함께</span>
        </div>
        <p class="brand-value__dsc text">
          브랜드와 가맹점이 함께 성장할 수<br/>
          있도록 상생을 목표로 합니다.
        </p>
      </div>
    </div>
  </div>

  <div class="brand__identity">
    <div class="brand__header header header_sub">
      <h1 class="header__heading heading heading_level_3">Coffee Mentor Identity</h1>
      <p class="header__text text">
        프리미엄 무인카페, 커피 멘토만의<span class="_newline" /> 감성을 담은 새로운 브랜드 아이덴티티
      </p>
    </div>

    <div class="brand__header-sub header header_sub">
      <h4 class="brand__identity-heading header__heading heading heading_level_4">Brand Identity</h4>
      <p class="brand__identity-text header__text text">
        커피의 맛을 좌우하는 원두 분쇄기인 핸드밀을<span class="_newline" /> 커피로 형상화하였으며,<span class="_newline_pc" />
        어둠속에서 빛을 밝혀주는<span class="_newline" /> 등대를 멘토의 사전적 의미와 연결지어 표현합니다.
      </p>
    </div>

    <div class="brand__identity-image"><img class="brand__identity-img" src="/images/brand_identity.png" alt="identity"/></div>

    <div class="brand__header-sub header header_sub">
      <h4 class="brand__identity-heading header__heading heading heading_level_4">Color Palette</h4>
      <p class="brand__identity-text header__text text">
        메인 컬러는 커피 멘토의 청결함과 고급스러움을,<span class="_newline" /> 서브 컬러는 등대의 밝은 빛을 표현합니다.
      </p>
    </div>

    <div class="brand__color">
      <div class="brand__color-item text">Main Color</div>
      <div class="brand__color-item text">Sub Color</div>
      <div class="brand__color-item text">Sub Color</div>
    </div>

    <div class="brand__identity-guide text text_small">
      커피멘토의 BI는 메뉴얼에 의거한 규정사항을  준수해야 합니다.<br />
      지정된 컬러를 반드시 사용하고, BI의 무단변형도 일체 불허합니다.
    </div>
  </div>
</section>
